import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import HouseDesignCard from "@/components/builder/estimator-tool/HouseDesignCard.vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseDesignFilter from "@/components/builder/estimator-tool/HouseDesignFilter.vue";
  import BuilderEstimatorStepTitle from "@/components/builder/estimator-tool/BuilderEstimatorStepTitle.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HousesDesignsGrid',
  props: {
    houses: {},
    updateSelectHouseDesign: { type: Function }
  },
  emits: ["onNotHousesFound"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);
  const props = __props;
  const emits = __emit;
  const houses = ref<HouseDesignInterface[]>([]);

  const updateHouses = (filteredHouses: HouseDesignInterface[]) => {
    houses.value = filteredHouses;
  };

  onMounted(() => {
    houses.value = props.houses;
  });

  watch(
    () => props.houses,
    (newHouses) => {
      if (newHouses.length === 0 && props.houses.length > 0) {
        emits("onNotHousesFound");
      }

      houses.value = newHouses;
    },
    { deep: true, immediate: true }
  );

  const handleViewFloorPlan = (houseId: string) => {
    props.updateSelectHouseDesign({ houseDesignId: houseId });
  };

const __returned__ = { isDesktop, props, emits, houses, updateHouses, handleViewFloorPlan, onMounted, ref, watch, HouseDesignCard, get HouseDesignInterface() { return HouseDesignInterface }, HouseDesignFilter, BuilderEstimatorStepTitle, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})